import { getEmbarcacaoAcomodacoes } from "./embarcacoes.gateway";
import { isEmbarcacaoAcomodacoesEmpty } from "./embarcacoes.types";
import type { EmbarcacaoAcomodacoes, EmbarcacaoAcomodacoesState } from "./embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

export const ACOMODACOES_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const ACOMODACOES_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const ACOMODACOES_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const ACOMODACOES_ERROR_MESSAGE = "Não foi possível carregar as Acomodações da embarcação.";

const ACOMODACOES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoAcomodacoes> = {
  load: getEmbarcacaoAcomodacoes,
  isEmpty: isEmbarcacaoAcomodacoesEmpty,
  messages: {
    sessionExpired: ACOMODACOES_SESSION_EXPIRED_MESSAGE,
    forbidden: ACOMODACOES_FORBIDDEN_MESSAGE,
    notFound: ACOMODACOES_NOT_FOUND_MESSAGE,
    error: ACOMODACOES_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoAcomodacoesResult extends EmbarcacaoAcomodacoesState {
  reload: () => void;
}

/**
 * Consulta as Acomodações da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoAcomodacoes(id: string): UseEmbarcacaoAcomodacoesResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, ACOMODACOES_QUERY);

  return { ...state, acomodacoes: data };
}
